import React from 'react'
import "./Eror.css"

function Eror() {
  return (
    <div>
       <div class="conatiner"><span class="numer">4</span>
  <div class="circle">
    <div class="drops"></div>
    <div class="drops"></div>
    <div class="hand"></div>
    <div class="hand rgt"></div>
    <div class="holder">
      <div class="bob">
        <div class="nose"></div>
        <div class="face">
          <div class="mouth">
            <div class="tongue"></div>
          </div>
        </div>
        <div class="ear"></div>
        <div class="ear rgt"></div>
        <div class="neck"></div>
      </div>
    </div>
  </div><span class="numer">4</span>
</div>
    </div>
  )
}

export default Eror
